/**
 * Created by: cparaschiv
 * Date: 30.04.2013, 17:21
 */

(function() {
    'use strict';

    var CLOSE = "close",
        ENABLE = "enable",
        ISOPEN = "isOpen",
        MAX = "max",
        MIN = "min",
        OPEN = "open",
        VALUE = "value",
        TEXT = "text",
        unwrap = TS.unwrap;

})();